/**
 * GIWAHS Adaptive Journey Core Engine — JourneyErrors (AJIP-16.02.003 · WS9)
 * ---------------------------------------------------------------------
 * Typed error hierarchy. Every failure path inside the Core Engine
 * returns or throws one of these subclasses. Raw `Error` throws inside
 * engine code are prohibited by governance.
 */

class JourneyError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = this.constructor.name;
    this.details = Object.freeze({ ...details });
    // Capture stack on V8 when available; otherwise leave default.
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}

class InvalidRequestError extends JourneyError {}
class InvalidTransitionError extends JourneyError {}
class NotRegisteredError extends JourneyError {}
class FlagDisabledError extends JourneyError {}
class PermissionError extends JourneyError {}
class ConfigError extends JourneyError {}

const ERROR_TYPES = Object.freeze([
  'JourneyError',
  'InvalidRequestError',
  'InvalidTransitionError',
  'NotRegisteredError',
  'FlagDisabledError',
  'PermissionError',
  'ConfigError',
]);

export {
  JourneyError,
  InvalidRequestError,
  InvalidTransitionError,
  NotRegisteredError,
  FlagDisabledError,
  PermissionError,
  ConfigError,
  ERROR_TYPES,
};
